import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";

import RichEditor from "../../../../../../components/common/richEditor/RichEditor";
import Button from "../../../../../../components/common/button/Button";
import ModalWrapper from "../../../../../../components/common/modalWrapper/ModalWrapper";

import SamplePitches from "./samplePitches/SamplePitches";
import ErrorOverlay from "./ErrorOverlay";

import { Mixpanel } from "../../../../../../actions/mixpanel.actions";
import { PROJECT_PITCH_IT_FORM } from "../../../../../../actions/project.actions";

import styles from "./PitchItForm.scss";

class PitchItForm extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      common,
      errorOverlay,
      handleSubmit,
      invalid,
      pristine,
      submitting
    } = this.props;

    return (
      <div className={styles.pitchItForm}>
        {common.error && (
          <ErrorOverlay onClose={errorOverlay} error={common.error} />
        )}

        <div className={styles.content}>
          <h2 className={styles.title}>The Pitch</h2>

          <Form onSubmit={handleSubmit}>
            <div className={styles.form}>
              <div className={styles.subtitle}>
                TAILOR YOUR PITCH - BE SURE TO INCLUDE:
                <br />
                <br />
                1. What specific experience in your background qualifies you to
                this role? And where did you hone those skills?
                <br />
                <br />
                2. Why are you the right person for this role? Include some of
                your particular attributes/qualities/skills.
                <br />
                <br />
                And remember:
              </div>

              <div className={styles.subtitle}>
                <ul>
                  <li className={styles.listItem}>
                    It’s not a cover letter, so no need to address or sign it.
                  </li>
                  <li className={styles.listItem}>
                    Saying “look no further” guarantees that they will. Don’t
                    blame us, it’s science.
                  </li>
                  <li className={styles.listItem}>
                    The company will have access to your profile with resume
                    &amp; LinkedIn - no need to repeat your work history
                    verbatim.
                  </li>
                  <li className={styles.listItem}>
                    Profile not up to date?{" "}
                    <Link
                      to="/member/profile"
                      onClick={() =>
                        Mixpanel.track("Member - Pitch It - Update Profile")
                      }
                    >
                      {" "}
                      Head over first to fix it up{" "}
                    </Link>
                  </li>
                </ul>
              </div>

              <div className={styles.subtitle}>
                If you’re still stumped, check out these
                <ModalWrapper Modal={SamplePitches} inlineTrigger>
                  <span
                    className={styles.modalTrigger}
                    onClick={() =>
                      Mixpanel.track("Member - Pitch It - Sample Pitches")
                    }
                  >
                    {" "}
                    sample Pitches.
                  </span>
                </ModalWrapper>
              </div>

              <div className={styles.dividerDouble} />

              <Field
                name="pitch"
                component={RichEditor}
                className={styles.editor}
                maxLength={1001}
              />

              <div className={styles.dividerDouble} />

              <div className={styles.submitButton}>
                <Button
                  isDisabled={invalid || submitting || pristine}
                  isPrimary
                  type="submit"
                  size="large"
                  label="SUBMIT PITCH"
                  onClick={() => Mixpanel.track("Member - Pitch It - Submit")}
                />
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

PitchItForm = reduxForm({
  form: PROJECT_PITCH_IT_FORM,
  enableReinitialize: true
})(PitchItForm);

PitchItForm = connect(state => {
  return {
    initialValues: state.project.match.pitch,
    saving: state.user.loading
  };
})(PitchItForm);

export default PitchItForm;



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/matches/components/pitchItForm/PitchItForm.js